import { AccountRefCode, PagingResponse, RefCode, Withdraw } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _WithdrawService {
  public getRequestWithdraw(page: number, is_successed?: number) {
    return HttpService.get<PagingResponse<Withdraw>>(
      `/withdraws?page=${page}&is_successed=${is_successed}`
    );
  }

  public createWithdrawRequest(bodyCreate: Withdraw) {
    return HttpService.post<Withdraw>("/withdraws", {
      body: { ...bodyCreate },
    });
  }
}

const WithdrawService = new _WithdrawService();

export default WithdrawService;
